// src/components/Testimonial/Testimonial.jsx
import React, { useState, useRef, useEffect } from "react";
import "./Testimonial.css";
import founderLogo from "../../assets/logo_circle.png";
import { useTranslation } from "react-i18next";

/* ---- tiny reveal-on-scroll hook ---- */
function useReveal(options = { threshold: 0.18, rootMargin: "0px 0px -10% 0px" }) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!ref.current || inView) return;
    if (!("IntersectionObserver" in window)) {
      setInView(true);
      return;
    }
    const io = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setInView(true);
        io.disconnect();
      }
    }, options);
    io.observe(ref.current);
    return () => io.disconnect();
  }, [inView, options]);

  return [ref, inView];
}

const Testimonial = () => {
  const { t } = useTranslation();
  const [quoteRef, quoteIn] = useReveal();

  // i18n strings with safe fallbacks
  const heading = t("testimonial.heading", {
    defaultValue: "Our Commitment to Service",
  });
  const quote = t("testimonial.quote", {
    defaultValue:
      "My mission is to create opportunities for those who truly deserve them, when you hire the right people, excellence naturally follows.",
  });
  const name = t("testimonial.name", { defaultValue: "Maximus Trinchini" });
  const title = t("testimonial.title", { defaultValue: "Founder & President" });
  const company = t("testimonial.company", { defaultValue: "Vision Sécurité Inc" });
  const logoAlt = t("testimonial.logoAlt", { defaultValue: "Vision Sécurité Logo" });

  return (
    <section className="testimonial" aria-labelledby="testimonial-heading">
      <div className="testimonial__container">
        <div
          ref={quoteRef}
          className={`testimonial__content reveal reveal--up ${quoteIn ? "in" : ""}`}
        >
          <div className="testimonial__header">
            <h2
              id="testimonial-heading"
              className="testimonial__heading reveal-item"
              style={{ transitionDelay: "80ms" }}
            >
              {heading}
            </h2>
            <div
              className="testimonial__accent-line reveal-item"
              style={{ transitionDelay: "120ms" }}
            />
          </div>

          <div className="testimonial__quote-section">
            <div
              className="testimonial__quote-wrapper reveal-item"
              style={{ transitionDelay: "170ms" }}
            >
              <div className="testimonial__quote-mark">"</div>
              <blockquote className="testimonial__quote">{quote}</blockquote>
            </div>

            <div
              className="testimonial__author reveal-item"
              style={{ transitionDelay: "220ms" }}
            >
              <div className="testimonial__author-image">
                <img
                  src={founderLogo}
                  alt={logoAlt}
                  className="testimonial__logo-image"
                />
              </div>
              <div className="testimonial__author-info">
                <div className="testimonial__name">{name}</div>
                <div className="testimonial__title">{title}</div>
                <div className="testimonial__company">{company}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
